import { ComponentPropsWithRef, memo } from 'react';
import { SportIconId } from '../../../types';
import { getSportIcon } from '../../utils/getSportIcon';
import { Icon } from '../Icon';

interface Props extends ComponentPropsWithRef<'svg'> {
  sportId: SportIconId;
}

export const SportIcon = memo(({ sportId, ...props }: Props) => {
  const iconName = getSportIcon(sportId);

  return <Icon name={iconName} {...props} />;
});
